module.exports = __webpack_public_path__ + "static/media/loading_reports.7f0c7f1f.gif";